import axios from "axios";

export default {
  namespaced: true,
  state: {
    salescosts: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    salescostsMessage: ''
  },
  mutations: {
    CLEAR_SALESCOSTS(state) {
      state.salescosts = [];
    },
    RECEIVED_SALESCOSTS(state, payload) {
      state.salescosts = payload;
      state.isReceiving = false;
    },
    RECEIVED_SALESCOST(state, payload) {
      let find = state.salescosts.find(i=>i._id==payload._id);
      state.isReceiving = false;
      if(find==null){
        state = Object.assign(state, { salescosts: [payload, ...state.salescosts] });
      }
      else {
        let index = state.salescosts.findIndex(salesorder => salesorder._id === payload._id);
        state.salescosts.splice(index, 1, payload);
      }
    },
    RECEIVING_SALESCOSTS(state) {
      state.isReceiving = true;
    },
    RECEIVING_SALESCOST(state) {
      state.isReceiving = true;
    },
    RECEIVING_TRANSACTIONS(state) {
      state.isReceiving = true;
    },
    RECEIVED_TRANSACTIONS(state) {
      state.isReceiving = false;
    },
    UPDATED_SALESCOST(state, payload) {
      let index = state.salescosts.findIndex(i => i._id==payload._id);
      state = Object.assign(state, {
        salescosts: state.salescosts.map((salesorder, i) => {
          if (i === index) {
            return Object.assign({}, salesorder, payload);
          }
          return salesorder;
        }),
        isUpdating: false,
        salescostsMessage: 'SalesCosts has been updating!',
      })
    },
    UPDATING_SALESCOST(state) {
      state.isReceiving = true;
    },
    DELETED_SALESCOST(state, payload) {
      let indexToDelete = state.salescosts.findIndex(salesorder => salesorder._id === payload._id);
      let salescosts = [...state.salescosts];
      salescosts.splice(indexToDelete, 1);
      state = Object.assign(state, {
        salescosts: [...salescosts],
        isDeleting: false,
        idToDelete: null,
        salescostsMessage: 'SalesCost has been Deleted!',
      });
    },
    DELETING_SALESCOST(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload._id;
    },
  },
  actions: {
    async insertSalesCostRequest({dispatch}, payload) {
      dispatch("receivingSalesCosts");
      var token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/salesorder';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      let response = await axios({method: "post", url: url, headers: headers, data: data});
      console.log('so', response.data);
      dispatch("receiveSalesCost", response.data);
      return response.data;
    },
    async insertSOTransactionRequest({dispatch}, payload) {
      try{
        dispatch("receivingTransactions");
        delete payload['branditems'];
        delete payload['_id'];
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/insert/sotransaction/" + payload.salesorderid;
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "post", url: url, headers: headers, data: payload });
        dispatch("receiveTransactions");
        return response.data;
      }
      catch(e){console.log(e)}
    },
    async getSalesCostsRequest({dispatch}) {
      dispatch("receivingSalesCosts");
      let token = localStorage.getItem('token');
      console.log(token);
      let url = 'https://api.tradexc.com:3000/get/salescosts';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: header})
      .then(res => {
        dispatch("receiveSalesCosts", res.data);
      })
    },
    async getSalesCostRequest({dispatch}, id) {
      dispatch("receivingSalesCost");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/salesorder/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get",url: url,headers: header})
      .then(response => {
        dispatch("receiveSalesCost", response.data);
      })
    },
    async findSalesCostsRequest({dispatch}, payload) {
      try{
        dispatch("receivingSalesCosts");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/salescosts';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveSalesCosts", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async deleteSalesCostsRequest({dispatch}, payload) {
      try{
        console.log(payload)
        dispatch("updatingSalesCost");
        let token = localStorage.getItem("token");
        let url = "https://api.tradexc.com:3000/delete/salescosts/" + payload._id;
        console.log(url)
        let headers = {"Content-Type": "application/json", Authorization: "Bearer " + token};
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("receiveSalesCost", response.data);
        return response.data;
      }
      catch(e){return null}
    },
    async updateSalesCostRequest({dispatch}, payload) {
      dispatch("receivingSalesCost");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/update/salescost';
      var headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      console.log(payload)
      let response = await axios({method:"put", url:url, headers: headers, data: payload});
      console.log(response.data);
      for(var i in response.data){
        let item = response.data[i];
        dispatch("receiveSalesCost", item);
      }
      
      return response.data;
    },
    async runSalesCostRequest({dispatch}, payload) {
      dispatch("receivingSalesCost");
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/run/salescost';
      var headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      console.log(payload)
      let response = await axios({method:"post", url:url, headers: headers, data: payload});
      console.log(response.data);
      for(var i in response.data){
        let item = response.data[i];
        dispatch("receiveSalesCost", item);
      }
      
      return response.data;
    },
    clearSalesCosts({commit}) {
      commit("CLEAR_SALESCOSTS")
    },
    receiveSalesCosts({commit}, payload) {
      commit("RECEIVED_SALESCOSTS", payload)
    },
    receiveSalesCost({commit}, payload) {
      commit("RECEIVED_SALESCOST", payload)
    },
    receivingSalesCosts({commit}) {
      commit("RECEIVING_SALESCOSTS")
    },
    receivingSalesCost({commit}) {
      commit("RECEIVING_SALESCOST")
    },
    receivingTransactions({commit}) {
      commit("RECEIVING_TRANSACTIONS")
    },
    receiveTransactions({commit}) {
      commit("RECEIVED_TRANSACTIONS")
    },


    updateSalesCost({commit}, payload) {
      commit("UPDATED_SALESCOST", payload)
    },
    updatingSalesCost({commit}) {
      commit("UPDATING_SALESCOST")
    },
    deleteSalesCost({commit}, payload) {
      commit("DELETED_SALESCOST", payload)
    },
    deletingSalesCost({commit}, payload) {
      commit("DELETING_SALESCOST", payload)
    }
  },
};
